import { useEffect, useRef, useState } from "react";

import { initTimelineGpu } from "@/lib/timeline-gpu/init";
import type { TimelineGpuRuntime } from "@/lib/timeline-gpu/runtime-options";

export function useTimelineGpuCanvas(
  canvas: HTMLCanvasElement | null,
  runtime: TimelineGpuRuntime,
): { canDraw: boolean } {
  const [canDraw, setCanDraw] = useState(true);
  const runtimeRef = useRef(runtime);
  runtimeRef.current = runtime;

  useEffect(() => {
    if (canvas === null) {
      return;
    }

    let disposeGpu: (() => void) | undefined;
    let cancelled = false;
    const onRenderer = (): void => {
      setCanDraw(canvas.dataset.renderer !== "none");
    };
    canvas.addEventListener("timeline-renderer", onRenderer);

    void initTimelineGpu(canvas, () => runtimeRef.current).then((dispose) => {
      if (cancelled) {
        dispose();
        return;
      }
      disposeGpu = dispose;
    });

    return () => {
      cancelled = true;
      canvas.removeEventListener("timeline-renderer", onRenderer);
      disposeGpu?.();
    };
  }, [canvas]);

  return { canDraw };
}
